module.exports = "html, body {\n    margin: 0px;\n    padding: 0px;\n    height: 100%;\n}"